module.exports = __webpack_public_path__ + "assets/retina_TPerpBisectorDetailed.2a12e5312482c647751cebd633061513.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_TPerpBisectorDetailed.png
// module id = 736
// module chunks = 0